import React from 'react';
import { reduxForm, FieldArray } from 'redux-form';

import Forms from 'components/Forms';

const PolicySummaryForm = () => {
  return (
    <FieldArray
      name="policies"
      component={({ fields }: any) => {
        return fields.map((policy: string, index: number) => {
          const policyData = fields.get(index);
          return (
            <Forms.PolicySummary.Policy
              policy={policy}
              key={index}
              funds={policyData.fund_allocations}
            />
          );
        });
      }}
    />
  );
};

export default reduxForm({
  form: 'policySummary'
})(PolicySummaryForm);
